import script from "./PageContentSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageContentSection.vue?vue&type=script&lang=ts&setup=true"

import "./PageContentSection.vue?vue&type=style&index=0&id=12efd36b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12efd36b"]])

export default __exports__